// Get an instance of `PhoneNumberUtil`.
const phoneUtil = require("google-libphonenumber").PhoneNumberUtil.getInstance();

// const number = phoneUtil.parseAndKeepRawInput('202-456-1414', 'US');
// phoneUtil.getRegionCodeForNumber(number)

export const phoneNumberValidation = (phoneNumber, countryCode) => {
  if (!phoneNumber || !countryCode) {
    return false;
  }

  const number = phoneUtil.parseAndKeepRawInput(phoneNumber, countryCode);

  try {
    return phoneUtil.isValidNumberForRegion(number, countryCode.toUpperCase());
  } catch (error) {
    return false;
  }
}